import React from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';

interface ClaimLocationMapProps {
  lat: string;
  lng: string;
  onChange: (lat: string, lng: string) => void;
}

const ClaimLocationMap: React.FC<ClaimLocationMapProps> = ({ lat, lng, onChange }) => {
  const position = lat && lng ? [parseFloat(lat), parseFloat(lng)] : [40.7128, -74.006]; // Default: NYC

  function LocationMarker() {
    useMapEvents({
      click(e) {
        onChange(e.latlng.lat.toString(), e.latlng.lng.toString());
      },
    });
    return lat && lng ? <Marker position={position as [number, number]} /> : null;
  }

  return (
    <MapContainer center={position as [number, number]} zoom={13} style={{ height: 250, width: '100%' }}>
      <TileLayer
        attribution='&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <LocationMarker />
    </MapContainer>
  );
};

export default ClaimLocationMap;
